<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-class="scale-95 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transition duration-150 ease-in transform"
    leave-class="scale-100 opacity-100"
    leave-to-class="scale-95 opacity-0"
  >
    <div
      v-if="segmentListPopup"
      class="
        flex
        items-center
        justify-center
        fixed
        left-0
        bottom-0
        w-full
        h-full
        z-50
      "
      style="background-color: #00000099"
    >
      <div class="bg-white rounded-lg w-1/4 relative">
      <spinner :loading="segmentAddLoader" />
        <div class="flex flex-col items-start p-4">
          <div class="flex items-center w-full">
            <div class="text-gray-900 font-bold text-lg">New segment</div>
            <div
              class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
              @click="() => this.$store.commit('SEGMENT_LIST_POPUP', false)"
            >
              <closeIcon />
            </div>
          </div>
          <div class="form-control w-full mt-5">
            <select
              v-model="selectedSegment"
              class="select select-bordered"
              required
            >
              <option disabled="disabled" value="">Select Segment</option>
              <option value="create_segment">Crete new Segment</option>
              <option
                v-for="(item, index) in segmentList"
                :value="item"
                :key="index"
              >
                {{ item.title.slice(0, 30)
                }}{{ item.title.length > 30 ? '...' : '' }}
              </option>
            </select>
          </div>

          <hr class="w-full my-5" />
          <section class="w-full flex justify-center">
            <div class="mr-5">
              <button
                class="btn btn-primary btn-outline"
                @click="() => this.$store.commit('SEGMENT_LIST_POPUP', false)"
              >
                cancel
              </button>
            </div>
            <div class="">
              <button :disabled="segmentAddLoader" class="btn btn-primary" @click="handleAddNewSegment">
                Add
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import closeIcon from '../icons/closeIcon.vue';
import utils from '@/services/utils';
import Spinner from '@/components/spinner.vue';

export default {
  name: 'SegmentListModal',
  components: { closeIcon, Spinner },
  data() {
    return {
      selectedSegment: '',
      segmentAddLoader: false,
    };
  },
  computed: {
    segmentListPopup() {
      return this.$store.state.pipeline.segmentListPopup;
    },
    segmentList() {
      return this.$store.state.courses.segmentOnly;
    },
    user() {
      return this.$store.state.userDetails;
    },
  },
  mounted() {
    // if (!this.user) {
    //   this.$store.dispatch('getMyDetails', {});
    // }
  },
  watch: {
    selectedSegment(val) {
      if (val === 'create_segment') {
        this.$store.commit('SEGMENT_LIST_POPUP', false);
        this.$store.commit('NEW_SEGMENT_POPUP', true);
        this.selectedSegment = '';
      }
    },
  },
  methods: {
    async handleAddNewSegment() {
      try {
        this.segmentAddLoader = true;
        // console.log(this.selectedSegment?.users.length);
        // we will add new api to get count of user here
        // if (
        //   this.selectedSegment?.users.length +
        //     this.$store.state.pipeline.pipelineStudentsCount >
        //   this.user?.myAccess?.pipelineMemberLimit
        // )
        if (this.$store.state.pipeline.pipelineStudentsCount >
          this.user?.myAccess?.pipelineMemberLimit
        ) {
          utils.setStatusMsg(this, 'Maximum pipeline member exceed');
          this.selectedSegment = '';
          return this.$store.commit('SEGMENT_LIST_POPUP', false);
        }
        const segmentId = this.selectedSegment._id;
        await this.$store.dispatch('addSegmentToPipeline', {
          segmentId,
        });
        this.$store.dispatch('getPipelineDetails');
        this.selectedSegment = '';
        this.segmentAddLoader = false;
        this.$store.commit('SEGMENT_LIST_POPUP', false);
      } catch (error) {
        this.segmentAddLoader = false;
        this.selectedSegment = '';
        utils.setStatusMsg(this, error?.message);
        this.$store.commit('SEGMENT_LIST_POPUP', false);
      }
      return null;
    },
  },
};
</script>

<style></style>
